import { render, staticRenderFns } from "./VehicleEditorSidebar.vue?vue&type=template&id=055ff6da"
import script from "./VehicleEditorSidebar.vue?vue&type=script&lang=ts"
export * from "./VehicleEditorSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports